import React from 'react';

import { Input } from 'antd';
import FileUpload from '../../../../../../components/FileUpload';

export const TableCol = (action, status) => {
  return [
    {
      key: 'detail',
      dataIndex: 'detail',
      title: 'Details',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, detail: e.target.value })}
        />
      )
    },
    {
      key: 'number_of_ra',
      dataIndex: 'number_of_ra',
      title: 'Number of RA',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, number_of_ra: e.target.value })}
        />
      )
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments',
      render: (fileList, row) => (
        <FileUpload
          fileList={fileList}
          row={row}
          action={action}
          disabled={status === 1 || status === 2 || status === 3}
          status={status}
          isMandatory={true}
        />
      )
    },
    {
      key: 'apa_point',
      dataIndex: 'apa_point',
      title: 'APA Point'
    }
  ];
};
